import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const CurrencyDetailsModal = ({ show, setShow }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show.showCurrencyDetails}
      className="invoice-modal"
      onHide={() => setShow((prevState) => ({ ...prevState, showCurrencyDetails: false }))}
    >
      <Modal.Header>
        <Modal.Title>{t('How we calculate the currency rates')}</Modal.Title>
        <AiOutlineClose
          className="ml-auto cursor-pointer"
          size={24}
          onClick={() =>
            setShow((prevState) => ({
              ...prevState,
              showCurrencyDetails: false,
            }))
          }
        />
      </Modal.Header>
      <Modal.Body>
        <p>
          {t(
            "You can also invoice in EUR, USD, GBP, CHF, CAD, AUD, NOK, DKK, JPY and CNY. But the salary will be paid in SEK, at the swedish bank's exchange rate on the day the invoice is paid. Due to the fact that we cannot guarantee the rate today, the amount to your bank account as below does not match."
          )}
        </p>
        <p>
          {t('Contact us if you have any questions')}
          <a href="mailto:info@invozio.com">
            <u> info@invozio.com</u>
          </a>
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default CurrencyDetailsModal;